module.exports = __webpack_public_path__ + "media/insurance.a4e36462.webm";